
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ProfilesService } from 'src/app/_services/new-settings/profiles.service';

@Component({
    selector: 'app-plan',
    templateUrl: './plan.component.html',
    styleUrls: ['./plan.component.scss'],
    standalone: false
})
export class PlanComponent implements OnInit {

  allHistory: Object[] = [];
  currentPlanDetails: any;

  constructor(
    private profilesService: ProfilesService,
    private localstorageservice: LocalStorageService
  ) { }

  ngOnInit() {
    this.getCurrentPlanDetails();
    this.getPaymentHistory();
  };




/**
 * Get Plan transation history
 */
  getPaymentHistory() {
    const userNumber = this.localstorageservice.getItem('usernumber')
    const start = 0;

    this.profilesService.fetchpaymenttransactionhistory(userNumber, start).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.allHistory = res.data;
      } else {
        this.allHistory = []
      }

    });
  };


  /**
   * Get Current plan history
   */
  getCurrentPlanDetails() {
    const userNumber = this.localstorageservice.getItem('usernumber');
   this.profilesService.fetchcurrentplandetails(userNumber).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.currentPlanDetails = res.data;
      } else {
        this.currentPlanDetails = {};
      }

    });


  }


}
